const svgNS = "http://www.w3.org/2000/svg";
const lerp = (v0, v1, t) => {
  return (1 - t) * v0 + t * v1;
};

const rand = (i = 0, prefix = `_`) => ({
  i,
  prefix,
  next() {
    return `${this.prefix}${this.i++}`;
  },
});

const maskID = rand(0, `eye-mask-`);

class Eye {
  irisColors = [`#FF6224`, `#F39CCC`, `#B855FF`];

  constructor(circle) {
    this.uniqueId = maskID.next();

    this.svg = circle.closest(`svg`);

    this.irisFactor = 0.35;
    this.pupilFactor = 0.52;
    this.lerpRate = 0.1;

    this.irisColor =
      this.irisColors[Math.floor(Math.random() * this.irisColors.length)];

    this.white = circle;
    this.pos = {
      x: parseFloat(circle.getAttribute(`cx`)),
      y: parseFloat(circle.getAttribute(`cy`)),
    };
    this.radius = parseFloat(circle.getAttribute(`r`));

    this.group = document.createElementNS(svgNS, "g");
    this.group.classList.add("circle-eyeball");
    this.group.style.setProperty(
      "--animation-delay",
      `${Math.floor(Math.random() * 3000)}ms`,
    );
    this.white.after(this.group);
    this.group.appendChild(this.white);

    this.iris = document.createElementNS(svgNS, "circle");
    this.iris.classList.add("eyeball--iris");
    this.iris.setAttribute(`fill`, this.irisColor);
    this.iris.setAttribute(`cx`, this.pos.x);
    this.iris.setAttribute(`cy`, this.pos.y);
    this.iris.setAttribute(`r`, this.radius * 0.63);
    this.group.appendChild(this.iris);

    this.pupil = document.createElementNS(svgNS, "circle");
    this.pupil.classList.add("eyeball--pupil");
    this.pupil.setAttribute(`fill`, `black`);
    this.pupil.setAttribute(`cx`, this.pos.x);
    this.pupil.setAttribute(`cy`, this.pos.y);
    this.pupil.setAttribute(`r`, this.radius * 0.33);
    this.group.appendChild(this.pupil);

    this.pupilPos = {
      x: this.pos.x,
      y: this.pos.y,
    };

    this.irisPos = {
      x: this.pos.x,
      y: this.pos.y,
    };
    this.irisTarget = {};
    this.pupilTarget = {};

    this.mask = document.createElementNS(svgNS, "mask");
    this.mask.setAttribute(`id`, this.uniqueId);

    this.maskCircle = document.createElementNS(svgNS, "circle");
    this.maskCircle.setAttribute(`fill`, `white`);
    this.maskCircle.setAttribute(`cx`, this.pos.x);
    this.maskCircle.setAttribute(`cy`, this.pos.y);
    this.maskCircle.setAttribute(`r`, this.radius);
    this.maskCircle.classList.add(`eyeball--mask`);
    this.mask.appendChild(this.maskCircle);
    this.defs = document.createElementNS(svgNS, "defs");

    this.defs.appendChild(this.mask);
    this.svg.appendChild(this.defs);
    this.group.setAttribute(`mask`, `url(#${this.uniqueId})`);

    this.changePosition();
  }

  changePosition() {
    this.angle = Math.random() * Math.PI * 2;
    this.distance = Math.random() * 0.4 + 0.6;

    this.irisPos.x =
      this.pos.x +
      Math.sin(this.angle) * this.radius * this.irisFactor * this.distance;
    this.irisPos.y =
      this.pos.y +
      Math.cos(this.angle) * this.radius * this.irisFactor * this.distance;

    this.pupilPos.x =
      this.pos.x +
      Math.sin(this.angle) * this.radius * this.pupilFactor * this.distance;
    this.pupilPos.y =
      this.pos.y +
      Math.cos(this.angle) * this.radius * this.pupilFactor * this.distance;

    this.iris.setAttribute("cx", this.irisPos.x);
    this.iris.setAttribute("cy", this.irisPos.y);

    this.pupil.setAttribute("cx", this.pupilPos.x);
    this.pupil.setAttribute("cy", this.pupilPos.y);
  }
  destroy() {
    this.svg.appendChild(this.white);
    this.defs.remove();
    this.group.remove();
  }
}

export default {
  eyes: [],
  interval: null,
  init() {
    this.eyes = Array.from(document.querySelectorAll("circle.is-eyeball")).map(
      (circle) => new Eye(circle),
    );
    this.interval = setInterval(() => {
      this.eyes.forEach((eye) => eye.changePosition());
    }, 4000);

    const shapesChoice = document.querySelectorAll(".shapes.has-shapes-choice");
    shapesChoice.forEach((choices) => {
      const shapes = choices.querySelectorAll(".shapes--choice");
      const index = Math.floor(Math.random() * shapes.length);
      shapes[index].classList.add("is-active");
    });
  },
  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.eyes.forEach((eye) => eye.destroy());
    this.eyes = [];
  },
};
